import React from 'react';
import IntlMessage from '../../util/IntlMessages';
import NotificationManager from "../ReactNotifications/NotificationManager";

export default () =>{
    NotificationManager.create({
        type: 'error',
        title: <IntlMessage id={`notify.error.anyError`}/>,
    });
};